import PageLayout, { siteTitle } from "@/components/PageLayout";
import ApplicationPhotoService from "@/lib/services/application_photos";
import ApplicationPhotoPageImage from "@/components/inspiration/application_photos/application_photo_page_image";
import { loadConfig, extractIdFromSlug } from "@/lib/utils.js";
import { useState } from "react";
import { shareIcon, magnifyIcon, targetIcon, resizeFullIcon } from "@/lib/icons";
import ApplicationPhotoFeaturedProducts from "@/components/inspiration/application_photos/application_photo_featured_products";
import SimpleModal from "@/components/simple_modal";
import Clipboard from "@/components/clipboard";
import Link from "next/link";
import { is_mobile } from "@/lib/utils.js";
import Lightbox from "@/components/lightbox";
import InspirationBreadcrumbs from '@/components/inspiration/breadcrumbs'; 
import  GalleryService from "@/lib/services/galleries";
import Qs from 'qs';


function ApplicationPhotoPage({ id, gallery, app_photo, stylesheet, favicon, page_layout, cart_enabled, referer, mobile }) {
  const [showShare, setShowShare] = useState(false);
  const [hotSpotClickId, setHotSpotClickId] = useState('');
  const [hotSpotHoverId, setHotSpotHoverId] = useState('');
  const [lightBoxIndex, setLightBoxIndex] = useState(null);

  const showLightBox = (e) => {
    e.stopPropagation();
    setLightBoxIndex(0);
  }

  let breadcrumbs = []
  if (gallery) {
    breadcrumbs = [
      {path: (/galleries\/index/.test(referer || '') ? referer : '/lex-cms/inspiration/galleries/index' ), name: 'Galleries'  }, 
      {path: `/lex-cms/inspiration/gallery/${gallery.id}`, name: `${gallery.name} Gallery`  },
      {path: `/lex-cms/inspiration/application_photo/${app_photo.id }`, name:  app_photo.title  }
    ]
  }
  else {
     breadcrumbs =  [{path: (/application_photos\/index/.test(referer || '') ? referer : '/lex-cms/inspiration/application_photos/index' ), name: 'Application Photos'  },
      {path: `/lex-cms/inspiration/application_photo/${app_photo.id }`, name:  app_photo.title  } ]
  }

  const hideLightBox = () => {
    setLightBoxIndex(null);
    document.body.style.overflow = "visible";
  }


  if (typeof window !== "undefined") {
    var pageUrl = window.location.href;
  }

  const similarPhotosCriteria = () => {
    let q = {};
    if(app_photo.application_types && app_photo.application_types.length > 0)
      q['application_categories_id_eq'] = app_photo.application_types[0].id;
    if(app_photo.spaces && app_photo.spaces.length > 0)
      q['application_spaces_id_eq'] = app_photo.spaces[0].id;
    return q;
  }

  const updateHoverId = (id) => {
    setHotSpotHoverId(id);
  }

  const updateClickId = (id) => {
    setHotSpotClickId(id);
  }

  const portrait = () => {
    return app_photo.width < app_photo.height;
  }

  const renderHotspot = (app_photo) => {
    let t = this;
    let initialMarkers = []; 
    app_photo.product_hot_spots.forEach((node, i) => {
      initialMarkers.push({
        x: node.x,
        y: node.y, 
        id: i, 
        data: {
          product_id: node.product.id,
          product_name:  node.product.name,
          product_image_path: node.product.thumb_image,
          product_url: node.product.link_url,
          product_slug: node.product.slug
        },
        clicked: (hotSpotClickId == node.product.id)
      }); 
    })
    return <ApplicationPhotoPageImage markers={initialMarkers} app_photo={app_photo} updateHoverId={updateHoverId} updateClickId={updateClickId} hoverId={hotSpotHoverId} clickedId={hotSpotClickId} />;
  }

  return (
    <PageLayout
      page_layout={page_layout}
      stylesheet={stylesheet}
      favicon={favicon}
      cart_enabled={cart_enabled}
      title={app_photo.title}
      inspirationBreadcrumbs={<InspirationBreadcrumbs 
        breadcrumbs_path={breadcrumbs }
      /> }
      >
      <SimpleModal show={showShare} setShow={setShowShare}>
        <div className="share-content">
          <h4 className="share-heading">Share This Page</h4>
          <Clipboard pageUrl={pageUrl} />
        </div>
      </SimpleModal>
      <div className='lexcms-application-photo-page'>
        
        <div className='lexcms-app-photo-container'>
          <div className={`lexcms-app-photo-image-container ${portrait() ? 'is-portrait' : '' }`}>
            { renderHotspot(app_photo) }
            <div className='photo-short-meta-container'>
              <p className='image-title'>{app_photo.title}</p>
              <div className='action-buttons-container'>
                { !mobile && 
                  <a className='lexcms-regular-button lexcms-app-photo-action-link' onClick={(e) => {showLightBox(e)}}>
                    { resizeFullIcon } Enlarge Image
                  </a>
                }
                <a className='lexcms-regular-button lexcms-app-photo-action-link' onClick={() => {setShowShare(true)}}>
                  { shareIcon } Share Image
                </a>
                { (( app_photo.application_types?.length > 0) || ( app_photo.spaces?.length > 0)) && 
                  <Link href={{
                    pathname: '/lex-cms/inspiration/application_photos/index',
                    query: similarPhotosCriteria()
                  }}>
                    <a className='lexcms-regular-button lexcms-app-photo-action-link'>
                      { magnifyIcon } View Similar Photos
                    </a>
                  </Link>
                }
              </div>
            </div>
          </div>
          <div className='app-photo-meta-container'>
            <div className='details-container'>
              <div className='details-block'>
                <h4 className='image-details-heading'>Application Types: </h4>
                <p className='image-details-content'>{app_photo.application_types.map(type => type.name).join(', ')}</p>
              </div>
              {app_photo.spaces?.length > 0 &&
              <div className='details-block'>
                <h4 className='image-details-heading'>Spaces: </h4>
                <div className='image-spaces-content'>
                  {app_photo.spaces.map((space, i) => {
                    return <div className='space-pill' key={i}>{space.name}</div>;
                  })}
                </div>
              </div>
              }
              <div className='details-block photo-credits-block'>
                <h4 className='image-details-heading'>Photo Credits:</h4>
                <p className='image-details-content'>{app_photo.photographer_credits || 'Currently not listed'}</p>
              </div>
            </div>
            { app_photo.product_hot_spots?.length > 0 && 
              <ApplicationPhotoFeaturedProducts product_hot_spots={app_photo.product_hot_spots} hotSpotClickId={hotSpotClickId} />
            }
            { (!app_photo.product_hot_spots || app_photo.product_hot_spots.length == 0) && 
              <>
                <div className='featured-products-heading-container'>
                  <h4 className='featured-products-heading'>Products: </h4>
                </div>
                <div className='no-products-container'>
                  <p> { targetIcon } There are currently no products tagged to this photo </p>
                </div>
             </>
            }
          </div>
        </div>
        <Lightbox index={lightBoxIndex} images={[app_photo]} hideLightBox={hideLightBox} />
      </div>
    </PageLayout>
  );
}


export async function getServerSideProps(context) {
  const { req, params = {}, query = {} } = context;

  const token = req?.headers?.["lex-api-token"];
  const showValue = params.show;

  const id =
    typeof showValue === "string"
      ? showValue.split("?")[0]
      : null;

  let gallery;

  // Handle query parameters embedded in the dynamic route value.
  const embeddedQuery =
    typeof showValue === "string"
      ? showValue.split("?")[1]
      : null;

  const parsedQuery = embeddedQuery
    ? Qs.parse(embeddedQuery)
    : {};

  const galleryId =
    query.gallery_id ??
    params.gallery_id ??
    parsedQuery.gallery_id ??
    showValue?.gallery_id;

  const host = req?.headers?.host;

  let service = await ApplicationPhotoService.build(
    token,
    host
  );

  let resp;
  let config;

  let referer = req?.headers?.referer
    ?.split("/")
    .slice(3)
    .join("/");

  if (referer) {
    referer = `/${referer}`;
  } else {
    referer = "/lex-cms/inspiration/application_photos/index";
  }

  try {
    resp = await service.show(id);
    config = service.config;
  } catch (e) {
    console.log(e);

    return {
      notFound: true,
    };
  }

  if (galleryId) {
    const galleryService = await GalleryService.build(
      token,
      host
    );

    try {
      gallery = await galleryService.show(galleryId);
    } catch (e) {
      console.log(e);
    }
  }

  const pageLayout = loadConfig(service);
  const mobile = is_mobile(
    req?.headers?.["user-agent"]
  );

  return {
    props: {
      id,
      gallery: gallery || null,
      app_photo: resp,
      referer,
      ...pageLayout,
      mobile,
    },
  };
}

export default ApplicationPhotoPage;


